import type { FormasPagamentoFranquia_ItemRow } from '../../contracts/FormasPagamentoFranquia_ItemRow';

/**
 * A aplicação da forma na franquia (chamado 2026-0023): fpf_* null herda o padrão global e 0 é um
 * valor de verdade. Regras puras da tela; quem decide de fato é o backend.
 */
export function temAplicacaoNaFranquia(item: FormasPagamentoFranquia_ItemRow): boolean {
  return [
    item.fpf_possui_taxas,
    item.fpf_aceita_parcelado,
    item.fpf_taxa_mensal,
    item.fpf_taxa_transacao,
    item.fpf_taxa_transacao_tipo,
    item.fpf_parcelas_max,
    item.fpf_dias_para_receber
  ].some((valor) => valor !== null && valor !== undefined);
}

/** O prazo que vale nesta franquia. */
export function diasEfetivos(item: FormasPagamentoFranquia_ItemRow): number {
  return item.fpf_dias_para_receber ?? item.forma_pagamento_dias_para_receber ?? 0;
}

/** Quantas parcelas valem nesta franquia; null quando a forma não parcela. */
export function parcelasEfetivas(item: FormasPagamentoFranquia_ItemRow, padrao: number): number | null {
  if (item.forma_pagamento_codigo === 'CASH') return null;
  if ((item.fpf_aceita_parcelado ?? item.forma_pagamento_aceita_parcelado) !== 1) return null;
  return item.fpf_parcelas_max ?? item.forma_pagamento_parcelas_max ?? padrao;
}
